import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import registerServiceWorker from './registerServiceWorker';

import {createStore } from 'redux';
import {Provider} from 'react-redux';

import reducer from './reducers';

import EnvLoader from './util/EnvLoader';

import './index.scss';
import './css/Navigation.scss';
import './css/ContentContainer.scss';
import './css/Login.scss';
import './css/Schedule.scss';
import './css/Division.scss';
import './css/Card.scss';
import './css/Components.scss';
import './css/List.scss';
import './css/VideoContainer.scss';
import './css/Popup.scss';
import './css/Loading.scss';

//TODO: 개발모드에서만 사용하도록 수정.
const store = createStore(reducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

const appElement = document.getElementById("root");



EnvLoader().then(() => {
  ReactDOM.render(
    <Provider store={store}>
      <App />
    </Provider>
    , appElement);
  registerServiceWorker();
});



// WEBPACK FOOTER //
// ./src/index.js